import React, { useEffect, useRef } from 'react';
import './Features.css';

const Features = () => {
  const featuresRef = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, observerOptions);

    featuresRef.current.forEach(ref => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, []);

  const features = [
    {
      icon: 'fas fa-robot',
      title: 'Autonomous Installation',
      description: 'Revolutionary robotic system that automatically installs drip irrigation lines, reducing labor costs by 80%.'
    },
    {
      icon: 'fas fa-tint',
      title: 'Water Efficiency',
      description: 'Precision water delivery directly to plant roots with 90% efficiency, reducing water waste significantly.'
    },
    {
      icon: 'fas fa-dollar-sign',
      title: 'Cost Reduction',
      description: 'Making drip irrigation affordable for smallholder farmers through automated installation and reduced complexity.'
    },
    {
      icon: 'fas fa-seedling',
      title: 'Crop Optimization',
      description: 'Intelligent water management system that adapts to different crops and soil conditions for maximum yield.'
    }
  ];

  return (
    <section id="features" className="features">
      <div className="container">
        <h2>Why Choose Our System</h2>
        <p className="section-subtitle">
          Our revolutionary robotic drip irrigation system transforms farming by making precision irrigation accessible and affordable for farmers worldwide.
        </p>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="feature-card"
              ref={el => featuresRef.current[index] = el}
            >
              <div className="feature-icon">
                <i className={feature.icon}></i>
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
